export const proxyscript='https://geoplaza.vu.nl/gpzviewer/resources/feature_1.php';
